import { FC } from 'react'

import { Icon, IconName, IconSize } from 'ui/components/Icon'
import { Tooltip } from 'ui/components/Tooltip'

import { DueTooltipProps } from './DueTooltipProps'

import { DueCount, DueRow, TooltipContent } from './styles'

export const DueTooltip: FC<DueTooltipProps> = (props) => {
  const { id, alerts } = props

  return (
    <DueRow>
      {alerts?.map((el, index) => {
        const { count, label, type } = el

        switch (type) {
          case 'error':
            return (
              <DueCount key={`${index}-${id}`}>
                <Tooltip id={`docTooltip-${index}-${id}`} type="error" event="hover" content={<>{label?.join(', ')}</>}>
                  <TooltipContent>
                    <Icon name={IconName.EXCLAMATION} size={IconSize.S} />
                    {count}
                  </TooltipContent>
                </Tooltip>
              </DueCount>
            )
          case 'warning':
            return (
              <DueCount key={`${index}-${id}`}>
                <Tooltip
                  id={`docTooltip-${index}-${id}`}
                  type="warning"
                  event="hover"
                  content={<>{label?.join(', ')}</>}
                >
                  <TooltipContent>
                    <Icon name={IconName.EXCLAMATION_ORANGE} size={IconSize.S} />
                    {count}
                  </TooltipContent>
                </Tooltip>
              </DueCount>
            )
          case 'ok':
            return (
              <DueCount key={`${index}-${id}`}>
                <Icon name={IconName.CHECK_GREEN} size={IconSize.S} />
              </DueCount>
            )

          default:
            return null
        }
      })}
    </DueRow>
  )
}
